// Lazy-load the Razorpay Checkout JS once per session.
let _razorpayScriptPromise = null;

export function loadRazorpayCheckout() {
  if (typeof window === 'undefined') return Promise.resolve(false);
  if (window.Razorpay) return Promise.resolve(true);
  if (_razorpayScriptPromise) return _razorpayScriptPromise;

  _razorpayScriptPromise = new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    script.onload = () => resolve(true);
    script.onerror = () => {
      _razorpayScriptPromise = null;
      resolve(false);
    };
    document.body.appendChild(script);
  });
  return _razorpayScriptPromise;
}
